import React from "react";
import RotatingGallery from "../components/RotatingGallery"; // adjust path if needed

const MAROON = "#800020";

// Fill later. Examples:
// const galleryImages = ["/images/show1.jpg", "/images/show2.jpg"];
// or: [{ src: "/images/show1.jpg", alt: "La Cenerentola — Portland Opera" }, ...]
const galleryImages = [
  "images/bio/directing1.png",
    "images/bio/directing2.png",
      "images/bio/directing3.png",
];

const Bio = () => {
  const hasImages = Array.isArray(galleryImages) && galleryImages.length > 0;

  return (
    <section
      className="relative text-white"
      style={{
        background:
          "radial-gradient(1000px 500px at 50% -10%, rgba(128,0,32,0.25), transparent 60%) #000",
      }}
    >
      {/* Top accent line */}
      <div
        className="absolute inset-x-0 top-0 h-[2px]"
        style={{
          background:
            "linear-gradient(90deg, transparent, rgba(128,0,32,0.8), transparent)",
        }}
      />

      <div className="w-full max-w-5xl mx-auto px-6 py-12 md:py-16">
        {/* Glassy bio card */}
        <div
          className="rounded-3xl border bg-white/5 backdrop-blur-md p-6 md:p-8 shadow-[0_10px_40px_rgba(0,0,0,0.35)]"
          style={{ borderColor: "rgba(255,255,255,0.075)" }}
        >
          {/* Image + text row */}
          <div className="flex flex-col md:flex-row items-start md:items-center gap-8">
            {/* Image column */}
            <div className="w-full md:w-2/5">
              <div
                className="rounded-2xl overflow-hidden shadow-xl border outline-none focus:outline-none"
                style={{ borderColor: MAROON }}
              >
                <img
                  src="/images/headshot2.png"
                  alt="Performer Portrait"
                  className="w-full h-auto object-cover block outline-none focus:outline-none"
                  draggable="false"
                />
              </div>
              <p className="mt-3 text-sm/relaxed text-white/70">Photo by — add credit</p>
            </div>

            {/* Text column */}
            <div className="w-full md:w-3/5">
              <h1
                className="text-3xl md:text-4xl font-bold tracking-tight mb-3"
                style={{ color: MAROON }}
              >
                Bio
              </h1>

              <blockquote
                className="mb-5 pl-4 border-l-4 italic text-white/90"
                style={{ borderColor: MAROON }}
              >
                “Fine-tuned performances that land with the impact of emotional truth.”
                <span className="not-italic text-white/70"> — Boston Globe</span>
              </blockquote>

              <div className="text-lg md:text-xl leading-relaxed font-gidole space-y-5">
                <p>
                  Melory Mirashrafi is an Iranian-American artist making live theatre, music, and cultural works.
                </p>
                <p>
                  As a director, dramaturg, and performer, Melory has developed and presented work with Artists Repertory Theatre,
                  SpeakEasy Stage Company, Portland Center Stage, Third Rail Repertory Theatre, Gloucester Stage Company,
                  Portland Opera, Renegade Opera, National Queer Theatre, Ashland New Plays Festival, Queer Opera, and more,
                  praised by the Boston Globe for drawing “fine-tuned performances that land with the impact of emotional truth.”
                </p>
                <p>
                  Melory’s work has been recognized by SpeakEasy Stage (Thomas Derrah Emerging Artist Award; <em>English</em>),
                  Opera America (Robert L.B. Tobin Director-Designer Prize; Glück’s <em>Orfeo</em>), and LimeArts/20×20 Fringe
                  (Excellence in Technical Achievement Award; <em>Abundancia</em>). Melory is a Stage Directors &amp; Choreographers Fellow
                  (Pittsburgh Public Theater &amp; Portland Center Stage; <em>Young Americans</em>) and attendee of the MusaMadre
                  “One year for freedom of writing” residency in Sardinia, curated by Nassim Soleimanpour.
                </p>
                <p>
                  Melory has spent time on staff at the Huntington Theatre Company in Boston, American Conservatory Theatre in San Francisco,
                  and currently serves as Artistic &amp; Producing Associate at Artists Rep in Portland. Associate Member SDC.
                </p>
                <p>
                  Recent publications include the <em>Methuen Drama Book of Trans Plays</em> and Routledge’s
                  <em> Troubling Traditions: Canonicity, Theatre, and Performance in the US</em>.
                </p>
                <p>
                  Beyond theatre, Melory is a co-founder of the SWANA Rose Culture + Community Center (Artist Residency Program Co-Curator),
                  and vocalist of art-rock band CHERA CHERA.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Gallery */}
        <div className="mt-12">
          <h2
            className="text-2xl md:text-3xl font-bold tracking-tight mb-4"
            style={{ color: MAROON }}
          >
            Gallery
          </h2>

          {!hasImages ? (
            <div
              className="rounded-2xl border p-8 text-center text-sm md:text-base opacity-80"
              style={{ borderColor: MAROON, color: MAROON, background: "rgba(255,255,255,0.02)" }}
            >
              Gallery coming soon — add images to <code>galleryImages</code> above.
            </div>
          ) : (
            <RotatingGallery images={galleryImages} />
          )}
        </div>
      </div>
    </section>
  );
};

export default Bio;
